<template>
    <div class="label-condition" >
       <label class="label">{{title}}</label>
        <div class="slot">
                <slot/>
        </div>
    </div>
</template>
<script>
export default {
	name:'label-condition',
	props:['title'],
}
</script>
<style scoped>
.label-condition {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    /* margin-bottom: 5px; */
}
.label {
    border-left: 3px solid #323288;
    padding-left: 5px;
    font-size: 13px;
}
.slot {
    height: 32px;
    display: flex;
    align-items: center;
}
</style>
